import React from "react";
import { useLocation, useParams } from "react-router-dom";
import FlightResultsTopBar from "./FlightResultsTopBar";
import { useBookingFlow } from "../hooks/useBookingFlow";
import { useSearch } from "../../../../contexts/SearchContext";
import { isAgentFlightResultsListUrl } from "../../flightBookingPathUtils";
import { resolveFlightEngineShellStep } from "./flightEngineShellStep";

/** מסך נחיתה לפני חיפוש — ללא מנוע חיפוש כפול */
export function FlightSearchPageLayout({ children }) {
  return <div className="fw-page fw-page--flight-search">{children}</div>;
}

/** מסך תוצאות והמשך זרימה — סרגל חיפוש/מודאל טעינה זמינים בכל שלבי הוויזארד אחרי החיפוש הראשון */
export function FlightResultsPageLayout({ children }) {
  const { pathname } = useLocation();
  const { flightStep } = useParams();
  const { loading } = useSearch();
  const { currentStep } = useBookingFlow();
  const hideV1TopBar = Boolean(
    resolveFlightEngineShellStep({
      currentStep,
      onResultsListUrl: isAgentFlightResultsListUrl(pathname, flightStep),
      loading,
    })
  );
  return (
    <div className="fw-page fw-page--flight-results">
      {hideV1TopBar ? null : <FlightResultsTopBar />}
      {children}
    </div>
  );
}
